import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { buildHomeHeroFromSettings, normalizeHomeStats } from "../lib/homeContent";

function Stat({ value, label }) {
    return (
        <div>
            <div className="font-display text-3xl md:text-4xl font-bold text-white">{value}</div>
            <div className="text-[11px] uppercase tracking-widest text-white/60 mt-1">{label}</div>
        </div>
    );
}

export default function HomeHeroSection({ settings }) {
    const hero = buildHomeHeroFromSettings(settings);
    const stats = normalizeHomeStats(settings?.home_stats);

    return (
        <section className="hero-blueprint text-white" data-testid="home-hero">
            <div className="max-w-7xl mx-auto px-4 py-20 md:py-28 grid md:grid-cols-12 gap-10 items-center relative">
                <div className="md:col-span-7 fade-up">
                    <div className="inline-flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[var(--lz-orange)]" />
                        <span className="text-xs font-bold uppercase tracking-[0.4em] text-[var(--lz-orange)]">
                            {hero.badge}
                        </span>
                    </div>
                    <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold uppercase leading-[0.95] tracking-tight">
                        {hero.line1}
                        <br />
                        {hero.line2_prefix}{" "}
                        <span className="text-[var(--lz-orange)]">{hero.line2_highlight}</span>.
                        <br />
                        {hero.line3}
                    </h1>
                    <p className="mt-6 max-w-xl text-white/70 text-base md:text-lg">{hero.subtitle}</p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        <Link to={hero.cta_primary_url} className="lz-btn lz-btn-primary" data-testid="hero-cta-shop">
                            {hero.cta_primary_label} <ArrowRight className="w-4 h-4" />
                        </Link>
                        <Link
                            to={hero.cta_secondary_url}
                            className="lz-btn border-2 border-white text-white hover:bg-white hover:text-[var(--lz-navy)]"
                            data-testid="hero-cta-featured"
                        >
                            {hero.cta_secondary_label}
                        </Link>
                    </div>
                    {stats.length > 0 && (
                        <div
                            className="mt-12 grid gap-6 text-white/80"
                            style={{
                                gridTemplateColumns: `repeat(auto-fit, minmax(120px, 1fr))`,
                            }}
                        >
                            {stats.map((s, i) => (
                                <Stat key={`${s.label}-${i}`} value={s.value} label={s.label} />
                            ))}
                        </div>
                    )}
                </div>
                <div className="md:col-span-5 relative">
                    <div className="aspect-square border-2 border-[var(--lz-orange)] relative bg-[#1a1f26]">
                        {hero.image_url ? (
                            <img
                                src={hero.image_url}
                                alt={hero.image_alt}
                                className="absolute inset-0 w-full h-full object-cover"
                            />
                        ) : (
                            <div className="absolute inset-0 flex items-center justify-center text-white/40 text-xs uppercase">
                                Sin imagen
                            </div>
                        )}
                        {(hero.card_label || hero.card_text) && (
                            <div className="absolute -bottom-4 -right-4 bg-[var(--lz-orange)] text-[var(--lz-navy)] p-4 max-w-[220px]">
                                {hero.card_label && (
                                    <div className="text-[10px] font-bold uppercase tracking-[0.3em]">
                                        {hero.card_label}
                                    </div>
                                )}
                                {hero.card_text && (
                                    <div className="font-display text-2xl font-bold uppercase">{hero.card_text}</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
